import UriTemplate from 'uri-templates';
import {halClient} from '../hal';
import {BBModel} from '../bb_model';
import {context} from '../constants/context';

const bookableItem = {

    query(params) {
        return new Promise((resolve, reject) => {

            const queryParams = {
                company_id: params.company.id
            };

            const {resource, person, service} = params.cItem;

            // get services and resources
            if (typeof person === 'object' && params.item !== 'person') {
                queryParams.person_id = person.id;
            }

            // get people and resources
            if (params.item !== 'service') {
                queryParams.service_id = service.id;
            }

            // get services and people
            if (typeof resource === 'object' && params.item !== 'resource') {
                queryParams.resource_id = resource.id;
            }

            const queryUrl = this.constructQueryUrl(queryParams);

            halClient.$get(queryUrl, queryParams)
                .then(baseItems => this.buildItems(baseItems, params, resolve, reject))
                .catch(err => reject(err));
        });
    },

    constructQueryUrl(queryParams) {
        let apiUrl = `${context.apiUrl}/api/${context.apiVersion}`;
        // if we have an admin then append /admin/ to the request
        if (context.isAdmin) {
            apiUrl += '/admin';
        }
        const paramString = '/{company_id}/items{?service_id,resource_id,person_id}';
        const href = apiUrl + paramString;
        const queryUrl = new UriTemplate(href).fillFromObject(queryParams || {});
        return queryUrl;
    },

    buildItems(baseItems, params, resolve, reject) {

        const waitItems = [baseItems];
        if (params.wait) {
            waitItems.push(params.wait);
        }

        Promise.all(waitItems).then((resources) => {
            const firstResource = resources[0];
            firstResource.$get('items')
                .then((itemResponse) => {
                    // only build models from the resource types we are interested in
                    const matchingItems = itemResponse.filter(item => item.type === params.item);
                    this.buildModelsFromItems(matchingItems, resolve, reject);
                })
                .catch(err => reject(err));
        });
    },

    buildModelsFromItems(matchingItems, resolve, reject) {
        const bookableItemModels = matchingItems.map(item => new BBModel.BookableItem(item));
        const promises = bookableItemModels.map(model => model.ready);

        return Promise.all(promises)
            .then(() => resolve(bookableItemModels))
            .catch(err => reject(err));
    }

};

export {
    bookableItem
};
